<template>
  <article
    class="bg-surface-default-low flex flex-col gap-16 overflow-hidden rounded-[16px] p-12 md:flex-row md:items-center md:gap-56"
  >
    <div class="order-2 flex flex-col md:order-1 md:ml-24 md:w-1/2">
      <span class="text-static-default-low body-2 mb-2 mt-4">{{
        stepLabel
      }}</span>
      <h4 class="text-static-default-hi heading-2 mb-8">{{ heading }}</h4>
      <p class="text-static-default-low body-1 mb-4">{{ content }}</p>
    </div>

    <div class="order-1 md:order-2 md:w-1/2">
      <RevIllustration
        alt=""
        class="h-auto w-full object-cover"
        :height="252"
        role="presentation"
        :src="imageSrc"
        :width="448"
      />
    </div>
  </article>
</template>

<script lang="ts" setup>
import { RevIllustration } from '@ds/components/Illustration'

defineProps<{
  stepLabel: string
  heading: string
  content: string
  imageSrc: string
}>()
</script>
